import { fromJS } from 'immutable';

export const initialState = fromJS({
    memberHasActiveFacilityEnrollments: undefined,
    memberInvalidations: undefined,
});
